import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { FeaturedContent } from "@/components/landing/FeaturedContent";
import { Benefits } from "@/components/landing/Benefits";
import { PdfSupport } from "@/components/landing/PdfSupport";
import { Testimonials } from "@/components/landing/Testimonials";
import { FAQ } from "@/components/landing/FAQ";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { Footer } from "@/components/landing/Footer";

const Index = () => (
  <div className="min-h-screen">
    <Header />
    <Hero />
    <HowItWorks />
    <FeaturedContent />
    <Benefits />
    <PdfSupport />
    <Testimonials />
    <FAQ />
    <FinalCTA />
    <Footer />
  </div>
);

export default Index;
